import { Action } from './action';
import { Airport } from 'acscp/store';

export class SearchAirports extends Action {
    constructor(public query: string) {
        super();
    }
}

export class SearchAirportsComplete extends Action {
    constructor(public filteredResults: Airport[]) {
        super();
    }
}

export class ClearAirportsSearchResults extends Action {
}
